import { Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ChamadosService } from 'src/app/services/chamados.service';
import { TarefaService } from 'src/app/services/tarefa.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-modal-finalizar-tarefa',
  templateUrl: './modal-finalizar-tarefa.component.html',
  styleUrls: ['./modal-finalizar-tarefa.component.scss']
})
export class ModalFinalizarTarefaComponent implements OnInit, OnDestroy {
  @Input() tarefa;
  codigoChamado;
  opcao = 'apontar';
  finalizar = {
    is_externo: false,
    is_comercial: false,
    data_criacao: null,
    total_horas: ''
  };
  selector: string;
  newSubs: Subscription;
  horasTrabalhadas;
  finalizandoTarefa = false;

  constructor(
    public modal: NgbActiveModal,
    private tarefaService: TarefaService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private elemRef: ElementRef,
    private chamadosService: ChamadosService,
  ) {
    this.selector = elemRef.nativeElement.tagName.toLowerCase();
  }

  ngOnInit(): void {
    document.getElementsByTagName(this.selector)[0]['style']['zoom'] = '0.85';
    var chamado = this.tarefa.chamado_id.text.split('-');
    this.codigoChamado = chamado[0];    

    if(this.opcao === 'apontar') {
      this.finalizar.total_horas = this.tarefa.tempo_tarefa;
    }
    this.finalizar.data_criacao = this.tarefa.data_agendamento;
    this.isComercial();
  }

  ngOnDestroy(): void {
    this.newSubs?.unsubscribe();
  }

  private obterIdCliente(): number | null {
    const referenciaCliente = this.tarefa?.cliente_id;
    if (!referenciaCliente) {
      return null;
    }
    if (typeof referenciaCliente === 'object') {
      return referenciaCliente.id ?? null;
    }
    const idClienteNumerico = Number(referenciaCliente);
    return Number.isNaN(idClienteNumerico) ? null : idClienteNumerico;
  }

  private obterIdChamado(): number | null {
    const referenciaChamado = this.tarefa?.chamado_id;
    if (!referenciaChamado) {
      return null;
    }
    if (typeof referenciaChamado === 'object') {
      return referenciaChamado.id ?? null;
    }
    const idChamadoNumerico = Number(referenciaChamado);
    return Number.isNaN(idChamadoNumerico) ? null : idChamadoNumerico;
  }

  private montarPayloadHorasTrabalhadas(horas: string[]): object {
    return {
      objHorasTrabalhadas: {
        chamado_id: this.obterIdChamado(),
        cliente_id: this.obterIdCliente(),
        descricao: this.tarefa.descricao || this.tarefa.descricao_html || '',
        hora: horas[0],
        is_externo: this.finalizar.is_externo,
        is_comercial: this.finalizar.is_comercial,
        minuto: horas[1],
        tarefa_id: this.tarefa.tarefa_id
      }
    };
  }

  private executarFinalizacaoTarefa(): void {
    this.newSubs = this.tarefaService.finalizarTarefa({ tarefa: { id: this.tarefa.tarefa_id } })
      .subscribe({
        next: () => {
          this.toastr.show(this.translate.instant('FINALIZADO_SUCESSO'), '', environment.toastrConfig('success'));
          this.modal.close('finalizou');
        },
        error: (error) => {
          this.finalizandoTarefa = false;
          console.error('finalizarTarefa', error);
        }
      });
  }

  finalizarTarefa(): void {
    this.finalizandoTarefa = true;
    if (this.opcao === 'nao_apontar') {
      this.executarFinalizacaoTarefa();
      return;
    }

    const idCliente = this.obterIdCliente();
    const idChamado = this.obterIdChamado();
    if (!idCliente || !idChamado) {
      this.executarFinalizacaoTarefa();
      return;
    }

    if (this.opcao === 'apontar') {
      this.finalizar.total_horas = this.tarefa.tempo_tarefa;
    }

    const horas = this.finalizar.total_horas.split(':');
    const payload = this.montarPayloadHorasTrabalhadas(horas);

    this.newSubs = this.tarefaService.adicionarHorasTrabalhadas(payload).subscribe({
      next: () => this.executarFinalizacaoTarefa(),
      error: (error) => {
        this.finalizandoTarefa = false;
        console.error('finalizarTarefa', error);
      }
    });
  }

  verificaSeDesativa(): boolean {
    if (this.finalizandoTarefa) {
      return true;
    }

    if(this.opcao === 'apontar_custom') {
      if((this.finalizar.total_horas === null || this.finalizar.total_horas === '') || (this.finalizar.data_criacao === null || this.finalizar.data_criacao === '')) {
        return true;
      } else {
        return false;
      }
    } else {
      if(this.finalizar.data_criacao === null || this.finalizar.data_criacao === '') {
        return true;
      } else {
        return false;
      }
    }
  }

  zerarHoras(): void {
    this.finalizar.total_horas = '';
  }

  private isComercial() {
    const idCliente = this.obterIdCliente();
    if (!idCliente) {
      return;
    }
    var payload = {
      data_comparada: new Date(),
      cliente_id: idCliente
    }
    this.newSubs = this.chamadosService.obterHorarioComercial(payload).subscribe(
      (result) => {
        this.finalizar.is_comercial = result.is_comercial
      }, (error) => console.error('isComercial', error)
    )
  }
}
